import { Fragment, useState } from "react";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { useSelector, useDispatch } from "react-redux";
import { FormDropDownListById, FormInput} from "../../../forms/form-components";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer, Button } from "@progress/kendo-react-buttons";
import { rangeDateKeys, rangeDateTimeKeys, nonRangeDateKeys, nonRangeDateTimeKeys } from "../../../lib/utils";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const _rangeDateKeys = [{Id: "0", Title: "Keep Value"}, ...rangeDateKeys.filter(e => e.Title)];
const _rangeDateTimeKeys = [{Id: "0", Title: "Keep Value"}, ...rangeDateTimeKeys.filter(e => e.Title)];
const _nonRangeDateKeys = [{Id: "0", Title: "Keep Value"}, ...nonRangeDateKeys.filter(e => e.Title)];
const _nonRangeDateTimeKeys = [{Id: "0", Title: "Keep Value"}, ...nonRangeDateTimeKeys.filter(e => e.Title)];


export const ReportingViewPageKeyValues = props => {
    const {pageState, formState, onFormSave, onFormValueChange, onClose, ...other} = props;

    const rules = pageState.searchSchemaTemp.rules;
    let parameters = rules.filter(e => e.parameterId && e.parameterId > 0 && (e.dataTypeId == 4 || e.dataTypeId == 5));
    let fields = rules.filter(e => (!e.parameterId || e.parameterId <= 0) && (e.dataTypeId == 4 || e.dataTypeId == 5));

    const currentTheme = useSelector(state => state.currentTheme);

    const { t } = useTranslation();

    return (
        <Fragment>
        <div className="reporting-view-page-key-values">
            <Form    
                validator={()=>undefined}
                key={formState.formKey}
                initialValues={{...formState.formInitialValues}}
                render={(formRenderProps) => {
                    return (
                        <FormElement horizontal={false}
                                style={{
                                    // width: 250,
                                }}
                        >                       
                            <div className="toolbar">
                                <Toolbar>
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="save" onClick={onFormSave}>
                                                {t("reporting.view.save")}
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>                               
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="cancel" onClick={onClose}>
                                               {t("reporting.view.cancel1")}
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>                        
                                </Toolbar>            
                            </div>
                            <div className="form-content">
                            {
                                fields && fields.length > 0 &&
                                <div className="reporting-view-page-key-values-group">
                                    <div className="header">{t("reporting.view.fields")}</div>
                                    <div className="content">
                                    {
                                        fields.map((item, index) => {     
                                            if (item.dataTypeId == 4)
                                            {
                                                if (item.operatorName == "between")
                                                    return (
                                                        <div key={index} className="row">
                                                            <div style={{flex:1}}>
                                                                <Field
                                                                    id={`${item.componentId}`}
                                                                    name={`${item.componentId}`}
                                                                    label={item.fieldTitle}
                                                                    component={FormDropDownListById} 
                                                                    data={_rangeDateKeys} dataItemKey="Id" textField="Title"  
                                                                    onChange={e => 
                                                                        {
                                                                            onFormValueChange({...item, valueKey: e.value});
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                else
                                                    return (
                                                        <div key={index} className="row">
                                                            <div style={{flex:1}}>
                                                                <Field
                                                                    id={`${item.componentId}`}
                                                                    name={`${item.componentId}`}
                                                                    label={item.fieldTitle}
                                                                    component={FormDropDownListById} 
                                                                    data={_nonRangeDateKeys} dataItemKey="Id" textField="Title"  
                                                                    onChange={e => onFormValueChange({...item, valueKey: e.value})}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                            }
                                            else if (item.dataTypeId == 5)
                                            {
                                                if (item.operatorName == "between")
                                                {
                                                    return (
                                                        <div key={index} className="row">
                                                            <div style={{flex:1}}>
                                                                <Field
                                                                    id={`${item.componentId}`}
                                                                    name={`${item.componentId}`}
                                                                    label={item.fieldTitle}
                                                                    component={FormDropDownListById} 
                                                                    data={_rangeDateTimeKeys} dataItemKey="Id" textField="Title"   
                                                                    onChange={e => onFormValueChange({...item, valueKey: e.value})}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                else
                                                    return (
                                                        <div key={index} className="row">
                                                            <div style={{flex:1}}>
                                                                <Field
                                                                    id={`${item.componentId}`}
                                                                    name={`${item.componentId}`}
                                                                    label={item.fieldTitle}
                                                                    component={FormDropDownListById} 
                                                                    data={_nonRangeDateTimeKeys} dataItemKey="Id" textField="Title"   
                                                                    onChange={e => onFormValueChange({...item, valueKey: e.value})}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                            }
                                        })
                                    }
                                    </div>
                                </div>
                            }
                            </div>
                        </FormElement>
                    );
                }}
            />
        </div>        
        <style>
            {
                `
                .filter-form-value-keys-dialog
                {
                    z-index: 10012 !important;
                }
                .k-animation-container
                {
                    z-index: 10013 !important;
                }

                .reporting-view-page-key-values
                {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    flex: 1;
                    height: 100%;
                }

                /*form toolbar*/
                .reporting-view-page-key-values.toolbar .k-toolbar
                {
                  width: 100%;
                  border-left: none !important;
                  border-bottom: 1px solid ${currentTheme.separatorColor};
                  border-top: none !important;
                  border-right: none !important;
                  padding: 3px 4px 2px 0px;
                  background-color: ${currentTheme.appBarBg}; /*transparent;*/
                }

                .reporting-view-page-key-values .toolbar .k-button
                {
                  /*the toolbar buttons*/
                  border: none;
                  padding: 6px 8px;
                  background-color:transparent;
                }

                .reporting-view-page-key-values .toolbar .k-separator 
                {
                    border-color: ${currentTheme.appBarLinkColor};/* ${currentTheme.primary}*/
                }

                .reporting-view-page-key-values .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                .reporting-view-page-key-values .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                {
                    box-shadow: none !important;
                    border: none !important;
                }

                .reporting-view-page-key-values .toolbar .k-toolbar .k-button:active::before, .reporting-view-page-key-values .toolbar .k-toolbar .k-button:hover::before,
                .reporting-view-page-key-values .toolbar .k-toolbar .k-button:focus::before, .reporting-view-page-key-values .toolbar .k-toolbar .k-button:focus-within::before                        
                {
                    opacity: 0 !important;
                    border: none !important;
                    box-shadow: none !important;
                }

                .reporting-view-page-key-values .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                {
                    /*border: 1px solid ${currentTheme.componentBg} !important;*/
                    box-shadow: none !important;
                }                       

                .reporting-view-page-key-values .toolbar .k-toolbar .k-button .k-button-text
                {
                    font-size: 13px;
                    font-weight: 400;
                    color: ${currentTheme.appBarLinkColor};//${currentTheme.componentText};
                }

                .reporting-view-page-key-values .toolbar .k-button-icon
                {
                  font-weight: 500;
                  color: ${currentTheme.appBarLinkColor};/*${currentTheme.primary};*/
                }

                .reporting-view-page-key-values .toolbar .k-toolbar .k-button:hover .k-button-text
                {
                    font-weight: 700;
                    font-size: 12.2px;
                }
                /*form toolbar*/


                /*form content*/
                .reporting-view-page-key-values .form-content
                {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    overflow: auto;
                    padding: 8px;
                }
                /*form content*/


                .reporting-view-page-key-values .k-form
                {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    flex: 1;
                    overflow: hidden;
                }

                /*utils form classes*/
                .reporting-view-page-key-values-group
                {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    margin-bottom: 16px;
                    padding: 0;
                }

                .reporting-view-page-key-values-group > .header
                {
                    font-size: 14px;
                    font-weight: 700;
                    padding: 6px;
                    border-bottom: 1px solid ${currentTheme.componentBorderColor};
                }
                .reporting-view-page-key-values-group > .content
                {
                    flex:1;
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    padding: 10px 6px 6px 12px;
                }

                .reporting-view-page-key-values-group > .content > .row
                {
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;
                    margin-bottom: 16px;
                }

                .reporting-view-page-key-values-group > .content > .row .k-form-field
                {
                    margin-top: 0px;
                }
                /*utils form classes*/
                

                /*format input components*/
                .reporting-view-page-key-values .k-form .k-label
                {
                    font-size: 13px;
                    margin-bottom: 3px;
                }

                /*formatting inputs and drop down lists to make them thicker/thiner*/
                .reporting-view-page-key-values .k-form .k-input, .k-form .k-dropdownlist
                {                        
                    border-left: 3px solid ${currentTheme.primary};
                }

                .reporting-view-page-key-values .k-form .k-input, .k-form .k-dropdownlist .k-input-inner
                {
                    background-color: ${currentTheme.componentBg};
                }

                .reporting-view-page-key-values .k-form .k-input
                {
                }

                .reporting-view-page-key-values .k-dropdownlist button
                {
                }

                .reporting-view-page-key-values .k-dropdownlist .k-input-inner
                {
                }

                .reporting-view-page-key-values .k-form .k-input.k-invalid, .reporting-view-page-key-values .k-form .k-dropdownlist.k-invalid
                {
                    border-top-color: ${currentTheme.componentBorderColor};
                    border-bottom-color: ${currentTheme.componentBorderColor};
                    border-right-color: ${currentTheme.componentBorderColor};
                }

                .reporting-view-page-key-values .k-form .k-input:focus, .reporting-view-page-key-values .k-form .k-input.k-textarea:focus, .reporting-view-page-key-values .k-form .k-input.k-textarea:active, .reporting-view-page-key-values .k-form .k-dropdownlist:focus
                {
                    box-shadow: none !important;
                    outline: none;
                }

                .reporting-view-page-key-values .k-form .k-input-solid:focus-within
                {
                    box-shadow: none;
                }
                /*format input components*/
                `
            }
        </style>
    </Fragment>
    );
};